import { Injectable } from '@angular/core';
import {
    HttpUserEvent, HttpResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor,
    HttpErrorResponse, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent
} from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { AppAuthenticationService } from './app.authentication';
import 'rxjs/add/operator/do';
import { Router, ActivatedRoute } from '@angular/router';




@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AppAuthenticationService, private router: Router, private activeRoute: ActivatedRoute) {

    }

    isErrorDialogDisplayed = false;
    isRefreshingToken = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');


    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        return req.clone({ setHeaders: { 'Authorization': 'Bearer ' + token,  
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' } });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(this.addToken(request, this.authService.getToken())).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {

                // Every call we update our user info
            }
        }, (err: any) => {

            if (err instanceof HttpErrorResponse) {
                if (err.status === 500) {

                } else if (err.status === 401) {
                    this.router.navigate([`/Home`], { relativeTo: this.activeRoute});

                } else if (err.status === 404) {

                } else {
                    console.log('Error occurred!');

                }
            }
        });
    }


    handle500Error(error) {
        // console.log('Showing 500 Error dialog...');
    }

    handle400Error(error) {
        if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser();
        }
        return Observable.throw(error);
    }


    logoutUser() {
        // Route to the login page (implementation up to you)
       // this.authService.LogOff();
        return Observable.throw('');
    }


}
